import * as cons from './constants';
import { requestReducerMaker, initialState } from '../helper'

export const getAllStudent = (state = initialState, action) => requestReducerMaker(cons.GET_ALL_STUDENT, state, action);
export const getStudent = (state = initialState, action) => requestReducerMaker(cons.GET_STUDENT, state, action);
export const createStudent = (state = initialState, action) => requestReducerMaker(cons.CREATE_STUDENT, state, action);
export const updateStudent = (state = initialState, action) => requestReducerMaker(cons.UPDATE_STUDENT, state, action);
export const getStudentsForSelection = (state = initialState, action) => requestReducerMaker(cons.GET_STUDENTS_FOR_SELECTION, state, action);